import React from "react"
import { Row, Col } from "react-bootstrap"
import { linksBuilder } from "../../../services/utils/linksBuilder"
import { useGalleriesAction } from "../../actions/useGalleriesAction"
import CircleImages from "../../components/CirclesImages"
import Container from "../../components/Layout/Container"
import { Loader } from "../../components/Layout/Loader"
import Wrapper from "../../components/Layout/Wrapper"

const GalleriesResults = ({ galleries: galleriesData, searchTerm }) => {
  const { galleries, loading, loadingMore } = useGalleriesAction(
    galleriesData,
    searchTerm,
  )

  if (!galleries) {
    return null
  }

  return (
    <div className="pt-4">
      <Container>
        {loading && <Loader />}
        {!loading && (
          <Row>
            {galleries.data.map((gallery) => {
              return (
                <Col
                  xl={2}
                  lg={3}
                  md={4}
                  sm={6}
                  xs={12}
                  key={`galleries-${gallery.id}`}>
                  <CircleImages
                    title={gallery.name}
                    subtitle={gallery.address}
                    image={gallery.thumbnail}
                    to={linksBuilder.galleries(gallery.domain)}
                    href={`/galleries/[id]`}
                  />
                </Col>
              )
            })}
          </Row>
        )}
        {loadingMore && <Loader />}
      </Container>
    </div>
  )
}

export default GalleriesResults
